import React from "react";
import Masthead from '../Masthead';
import Listing from '../Listing';
import Conclusion from '../Conclusion';
import Header from '../../partials/Header';

export default function Home() {
    return (
        <>
            <Header/>
            <Masthead/>
            <Listing/>
            <Conclusion/>
        </>
    )
}